import { render, staticRenderFns } from "./DevicesStats.vue?vue&type=template&id=b42173ae&"
import script from "./DevicesStats.vue?vue&type=script&lang=js&"
export * from "./DevicesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports